import './LegalPages.css';

export default function AboutPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <a href="/" className="legal-back">← Back to Home</a>
        
        <h1>About Us</h1>
        <p className="legal-updated">Last updated: January 2026</p>

        <section>
          <h2>Our Mission</h2>
          <p>
            Nexus AI Recommendations was created with a simple goal: help Shopify merchants 
            increase their sales through truly intelligent product recommendations.
          </p>
          <p>
            Unlike basic recommendation systems that rely solely on product tags and descriptions, 
            our platform uses advanced machine learning to understand actual customer behavior—what 
            they view, click, add to cart, and purchase.
          </p>
        </section>

        <section>
          <h2>The Technology</h2>
          <p>
            Built on Microsoft's ML.NET framework, our recommendation engine employs collaborative 
            filtering algorithms that learn patterns across your entire customer base. This means 
            recommendations get smarter over time, adapting to changing trends and customer preferences.
          </p>
        </section>

        <section>
          <h2>Why Choose Us?</h2>
          <ul>
            <li><strong>Behavioral Intelligence:</strong> We track real customer actions, not just product metadata</li>
            <li><strong>Privacy First:</strong> Full GDPR and CCPA compliance built-in</li>
            <li><strong>Performance:</strong> Sub-100ms response times that won't slow your store</li>
            <li><strong>Transparency:</strong> Comprehensive analytics so you can see exactly what's working</li>
          </ul>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Have questions? We'd love to hear from you.
          </p>
          <p>
            <strong>Email:</strong> <a href="mailto:support@shopicraft-solutions.com">support@shopicraft-solutions.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
